
Module.prototype.fixToBottomOfPage = function ($el) {


	function fixToBottom() {

		// height is window height - top

		var top = $el.offset().top;
		var windowHeight = $(window).height();
		var height = windowHeight - top;

		$el.css({ height: windowHeight - top });

		//$el.css({ outline: '1px dotted blue' })

		// if ($el.data('iscroll')) {
		// 	$el.data('iscroll').refresh();
		// }

		if($el.hasClass("mCustomScrollbar")) {
			$el.mCustomScrollbar("update");
		}

	}

	var timer = null;

	$(window).on('resize', function () {
		if (timer != null) {
			clearTimeout(timer);
		}

		timer = setTimeout(fixToBottom, 50);
	});

	fixToBottom();

};

Module.prototype.action_updateTicket = function($el,val) {

	var proj = val.split("|")[1];
	var ticket = val.split("|")[0];
	var priority = encodeURIComponent(val.split("|")[2]);
	var $modal = $("#ModalDialog");
	$modal.find("div.modal-body").empty();
	$modal.modal({
		remote: "~/Ticket/UpdateModule".resolveUrl() + ("?html=true&ticketid=" + ticket + "&projectid=" + proj + "&priority=" + priority),
		backdrop: "static"
	});

	$modal.css("margin-left", "-" + ($modal.width()/2) + "px");
	$modal.off('loaded');
	$modal.on('loaded', $.proxy(this.updateModuleLoaded,this));
};

Module.prototype.action_createTicket = function($el,val) {
	var $modal = $("#ModalDialog");
	$modal.find("div.modal-body").empty();
	$modal.modal({
		remote: "~/Ticket/CreateModule".resolveUrl() + ("?html=true&projectid=" + val),
		backdrop: "static"
	});

	$modal.css("margin-left", "-" + ($modal.width()/2) + "px");
	$modal.off('loaded');
	$modal.on('loaded', $.proxy(this.createModuleLoaded,this));
};

Module.prototype.action_openAttachment = function($el, val) {
	window.open(("~/Ticket/GetAttachment?" + val).resolveUrl(), "attachment")
}

Module.prototype.action_aScroll = function($el,val) {
	var $cont = $el.siblings("div.attachScroll");
	if($cont && $cont.length > 0) {
		$cont.animate({scrollLeft: (810*val) + "px"}, 500);
	}
}

Module.prototype.action_exportTickets = function($el,val) {

	Module.fireModuleMethod("TicketSearchModule","exportTickets");
	Module.fireModuleMethod("ActivityFeedModule","exportTickets");
};

Module.prototype.updateModuleLoaded = function(data) {
	new TicketUpdateModule().init("#TicketUpdateModule");
};

Module.prototype.createModuleLoaded = function(data) {
	new TicketCreateModule().init("#TicketCreateModule");
};

Module.prototype.action_closeModal = function($el,val) {
	this.closeModal();
};

Module.prototype.closeModal = function() {

	var $modal = $("#ModalDialog");
	if($modal.length > 0) {
		$modal.modal("hide");
		$modal.removeData("modal");
		$modal.off('loaded');
	}
}